/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import React from 'react';
import { AIGeneralBlockCard } from '../../AIGeneralBlockCard';
import { Text } from '../../../atoms/Text/Text';
import './MetricRendererStyles.scss';
const baseClass = 'qmb-ui-MetricRenderer';
const TREND_ICON = {
    up: 'fa-light fa-arrow-trend-up',
    down: 'fa-light fa-arrow-trend-down',
    flat: 'fa-light fa-minus'
};
export function MetricRenderer({ block }) {
    const metric = block;
    return (React.createElement(AIGeneralBlockCard, { sections: [
            {
                label: metric.label,
                content: (React.createElement("div", { className: baseClass },
                    React.createElement(Text, { variant: "body", className: `${baseClass}__value` },
                        React.createElement("strong", null, String(metric.value))),
                    metric.trend && (React.createElement("i", { className: `${TREND_ICON[metric.trend]} ${baseClass}__trend ${baseClass}__trend--${metric.trend}` })),
                    metric.context && (React.createElement(Text, { variant: "body", className: `${baseClass}__context` }, metric.context)))),
                copyText: `${metric.label}: ${String(metric.value)}`
            }
        ] }));
}
